<template>
  <v-tooltip
    content-class="dfi-tooltip bottom dark"
    bottom
    nudge-bottom="10"
  >
    <template #activator="{ on }">
      <v-icon
        v-on="on"
        color="ContentPrimary"
        @click="switchTheme"
      >
        {{ $vuetify.theme.dark ? '$LightMode' : '$DarkMode' }}
      </v-icon>
    </template>
    <span>{{ $vuetify.theme.dark ? 'Light' : 'Dark' }} mode</span>
  </v-tooltip>
</template>

<script>
  export default {
    created() {
      const darkModeCookie = this.$cookies.get("app.darkMode") === "true" ? true : false;
      this.$vuetify.theme.dark = darkModeCookie;
    },
    methods: {
      switchTheme() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        this.$cookies.set("app.darkMode", this.$vuetify.theme.dark);
      },
    },
  };
</script>
